import { render, staticRenderFns } from "./salesrank.vue?vue&type=template&id=4d4c8319&scoped=true&"
import script from "./salesrank.vue?vue&type=script&lang=js&"
export * from "./salesrank.vue?vue&type=script&lang=js&"
import style0 from "./salesrank.vue?vue&type=style&index=0&id=4d4c8319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c8319",
  null
  
)

export default component.exports